import { render } from "./pagoExitosoScreen.vue?vue&type=template&id=16a7242f&scoped=true"
import script from "./pagoExitosoScreen.vue?vue&type=script&lang=js"
export * from "./pagoExitosoScreen.vue?vue&type=script&lang=js"

import "./pagoExitosoScreen.vue?vue&type=style&index=0&id=16a7242f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a7242f"]])

export default __exports__